import { Route, Routes } from "react-router-dom";

import EndOfTheYearQuestionnaire from "./pages/EndOfTheYearQuestionnaire";
import TaxPreparationOverview from "./pages/TaxPreparationOverview";

const TaxPreparation = () => {
  return (
    <Routes>
      <Route path="/" element={<TaxPreparationOverview />} />
      <Route
        path="/:type/:questionnaireId?"
        element={<EndOfTheYearQuestionnaire />}
      />
    </Routes>
  );
};

export default TaxPreparation;
